import React from 'react'
import Card from './card'
// import { View Project, FaGithub } from 'react-icons/fa'

import rlThumb from '../static/react-landing-page-thumb.png'
import roiThumb from '../static/rio-demo-thumb.png'
import entrybookThumb from '../static/entrybook-thumb.png'
import mobileBazarThumb from '../static/mobile-bazar-thumb.png'
import squareDashThumb from '../static/square-dash-thumb.png'
import ssrThumb from '../static/react-ssr-thumb.png'

const projectArray = [
    {
        title: 'React Landing Page',
        description: 'A landing page created with react and framer-motion for smooth animations',
        liveLink: 'https://s0npari11.github.io/react-landing-page',
        sourceCode: 'https://github.com/S0npaRi11/react-landing-page',
        thumb: rlThumb
    },
    {
        title: 'ROI Landing demo',
        description: 'A Landing page with scroll animations, made with vanilla HTML and CSS',
        liveLink: 'https://s0npari11.github.io/roi-demo/',
        sourceCode: 'https://github.com/S0npaRi11/roi-demo',
        thumb: roiThumb
    },
    {
        title: 'Entrybook',
        description: 'Entry book is an account-management software, especially one book accounting, where you can collaborate with others in the same accounting book.',
        liveLink: 'https://s0npari11.github.io/entrybook/#/',
        sourceCode: 'https://github.com/S0npaRi11/entrybook',
        thumb: entrybookThumb
    },
    {
        title: 'Mobilebazar',
        description: 'Mobilebazar is a second-hand mobile marketplace to buy referbished premium phones, equiped with a payment getway and an automatic email notifier. (Yhe project has been discontinued so some features may not work.)',
        liveLink: 'https://mobilebazar.herokuapp.com/',
        sourceCode: 'https://github.com/S0npaRi11/e-commerse-website-with-node.js',
        thumb: mobileBazarThumb
    },
    {
        title: 'react-SSR',
        description: 'A Movie information and rating website prototype with react.',
        liveLink: 'https://s0npari11.github.io/react-ssr/#/tv-shows/avengers',
        sourceCode: 'https://github.com/S0npaRi11/react-ssr',
        thumb: ssrThumb
    },
    {
        title: 'Square Dash - A JavaScript infinite runner game',
        description: 'Square Dash - A vanilla JavaScript Infinite runner game. Avoid obstacles with JUMP and DUCK. Randomly generates a pre-defined enemy with random speed. Challenging game-play.',
        liveLink: 'https://s0npari11.github.io/square-dash/index.html',
        sourceCode: 'https://github.com/S0npaRi11/square-dash',
        thumb: squareDashThumb
    }
]

const projects = () => {
    return (
        <section className="h-auto mx-10 font-quicksand">
            <h2 className="text-5xl font-semibold font-quicksand my-20 text-center text-primary block"> <span className="p-2 canvas-hover"> Projects </span> </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 md:grid-rows-2 gap-x-3 gap-10">
                
                {projectArray.map(work => (
                    <Card key={projectArray.indexOf(work)} title={work.title} description={work.description}  liveLink={work.liveLink} sourceCode={work.sourceCode} thumb={work.thumb} />
                ))}

            </div>
        </section>
    )
}

export default projects
